import { PrivacyCenterModule } from '@main/pc-types';
import React, { forwardRef } from 'react';
import { useSelector } from 'react-redux';

import { buildUseCdnQueryWithFallback } from '../../hooks';
import { selectWorkflowsV2Enabled } from '../App/selectors';
import { ActionsTakeControl } from './ActionsTakeControl';
import { WorkflowsTakeControl } from './WorkflowsTakeControl';

const useWorkflows = buildUseCdnQueryWithFallback(
  PrivacyCenterModule.WorkflowConfigs,
);

export interface TakeControlProps {
  /** Explicit onExited function with context of modal button ref */
  onExited: () => void;
}

/**
 * Switch between ActionsTakeControl and WorkflowsTakeControl based on a flag.
 */
export const TakeControl = forwardRef<HTMLButtonElement, TakeControlProps>(
  (props, ref) => {
    const workflowsV2Enabled = useSelector(selectWorkflowsV2Enabled);

    const { data: workflows } = useWorkflows();
    const hasWorkflows = (workflows?.nodes?.length ?? 0) > 0;

    if (workflowsV2Enabled && hasWorkflows) {
      return <WorkflowsTakeControl {...props} ref={ref} />;
    }
    return <ActionsTakeControl {...props} ref={ref} />;
  },
);

export default TakeControl;
